import React from 'react';
import times from 'lodash/times';
import Row from '../Row/Row';

interface Props {
  columnCount: number;
}

const TableLoader = ({ columnCount }: Props) => {
  return (
    <>
      {times(10).map((index) => (
        <Row key={index} isLoading={true} columnCount={columnCount} />
      ))}
    </>
  );
};

export default TableLoader;
